import CommunityTitle from 'src/refactor_components/community/threads/community-title';
import CommunityProfile from 'src/refactor_components/community/threads/community-profile';
import CommunityContents from 'src/refactor_components/community/threads/community-contents';
import { Dispatch, SetStateAction } from 'react';
import { BoxIcon } from '#atoms';

const QuestionInfo = ({
  setQuestionModalOpen,
  question
}: {
  setQuestionModalOpen: Dispatch<SetStateAction<boolean>>;
  question: any;
}) => {
  return (
    <div className="relative">
      <div className="flex flex-col pt-16 pb-40 fixed bottom-0 left-1/2 -translate-x-1/2 bg-black w-full z-100 rounded-t-16 max-h-[85%] h-fit max-w-939">
        <button
          type="button"
          className="self-end mx-20"
          onClick={() => setQuestionModalOpen(false)}
        >
          <BoxIcon type="x-white" onlyIcon width={14} height={14} />
        </button>
        <div className="flex flex-col gap-20 overflow-y-auto">
          <CommunityTitle category={question.category} title={question.title} />
          <CommunityProfile createdAt={question.createdAt}>
            <CommunityProfile.Consumer userName={'test'} />
          </CommunityProfile>
          <CommunityContents content={question.content} />
        </div>
      </div>
      <div
        className="fixed top-0 w-full h-full -translate-x-1/2 bg-black opacity-50 max-w-939 left-1/2"
        onClickCapture={() => setQuestionModalOpen(false)}
      />
    </div>
  );
};

export default QuestionInfo;
